var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableAlignTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0008 1.75C17.415 1.75 17.7508 1.41421 17.7508 0.999999C17.7508 0.585785 17.415 0.25 17.0008 0.25L1.05078 0.250026C0.636567 0.250027 0.300781 0.585814 0.300781 1.00003C0.300781 1.41424 0.636567 1.75003 1.05078 1.75003L17.0008 1.75ZM9.53111 3.46967C9.23822 3.17678 8.76335 3.17678 8.47045 3.46967L5.47045 6.46967C5.17756 6.76256 5.17756 7.23744 5.47045 7.53033C5.76335 7.82322 6.23822 7.82322 6.53111 7.53033L8.25078 5.81066V13C8.25078 13.4142 8.58657 13.75 9.00078 13.75C9.415 13.75 9.75078 13.4142 9.75078 13V5.81066L11.4705 7.53033C11.7633 7.82322 12.2382 7.82322 12.5311 7.53033C12.824 7.23744 12.824 6.76256 12.5311 6.46967L9.53111 3.46967Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableAlignTop);
export default __webpack_public_path__ + "static/media/table_align_top.9e18b20422018ec5e6d2f6e39ac9a213.svg";
export { ForwardRef as ReactComponent };